"use client"

import { useCallback } from "react"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

export function useRecaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const getToken = useCallback(
    async (action: string): Promise<string | null> => {
      if (!executeRecaptcha) {
        console.warn("[recaptcha] executeRecaptcha not available")
        return null
      }

      try {
        const token = await executeRecaptcha(action)
        return token
      } catch (error) {
        console.error("[recaptcha] Error getting token:", error)
        return null
      }
    },
    [executeRecaptcha]
  )

  return { getToken, ready: !!executeRecaptcha }
}
